import React, { useCallback, useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import { useAuth } from '~/hooks/auth';
import { useOrders } from '~/hooks/orders';
import { Realtime } from '~/services/firebase';
import { handlePrint } from '~/utils/handlePrint';

interface INotification {
  uid: string;
  description: string;
  type: string;
  link: string;
  company_id: string;
  user_id: string;
  created_at: any;
  created_at_formatted?: string;
}

// let audio: any;
let printUid = '';

const { REACT_APP_FILTER_ORDERS } = process.env;

const Notifications: React.FC = () => {
  const { user, company } = useAuth();
  const {
    loadOrdersTable,
    loadOrders,
    loadOrdersWithRangeDate,
    initialDate,
    initialHour,
    finalDate,
    finalHour,
  } = useOrders();
  const [notifications, setNotifications] = useState<INotification[]>([]);
  const [hasNewNotification, setHasNewNotification] = useState(false);
  const [init, setInit] = useState(false);

  const loadNotifications = useCallback(() => {
    const notificationsRef = Realtime.ref(`notifications/${user.uid}`);
    const startKey = notificationsRef.push().key;

    notificationsRef
      .orderByKey()
      .startAt(startKey)
      .on('child_added', data => {
        const value = {
          ...data.val(),
          uid: data.key,
        };

        console.log('value: ', value);

        setNotifications(current => [value, ...current]);
        setHasNewNotification(true);

        if (printUid !== data.key) {
          printUid = data.key || '';
          // console.log('_print');
          // console.log(data.key);

          const print =
            company.auto_print === '1' || company.auto_print === '2';

          if (REACT_APP_FILTER_ORDERS) {
            loadOrdersWithRangeDate({
              id: user.uid,
              initialDate,
              initialHour,
              finalDate,
              finalHour,
              isNew: print,
            });
          } else {
            if (!value.notPrintTableParcial) {
              loadOrders(user.uid, print);
            }
            loadOrdersTable();
          }

          if (company.print_table_orders === '1') {
            if (value.order?.table?.uid && value.notPrintTableParcial) {
              handlePrint({ order: value.order, company, cozinha: true });
            }
          }
        }

        // oscilator
        const context = new AudioContext();
        const oscillator = context.createOscillator();

        oscillator.type = 'sine';
        oscillator.connect(context.destination);
        oscillator.start();

        setTimeout(() => {
          oscillator.stop();
        }, 3000);
      });
  }, [
    user,
    loadOrders,
    loadOrdersTable,
    company,
    initialDate,
    initialHour,
    finalDate,
    finalHour,
    loadOrdersWithRangeDate,
  ]);

  useEffect(() => {
    if (company.app_domain && !init) {
      setInit(true);
      loadNotifications();
    }
  }, [loadNotifications, company, init]);

  const onPlay = useCallback(() => {
    const audioEl: any = document.getElementsByClassName('audio-element')[0];
    if (audioEl) {
      audioEl.play();

      setTimeout(() => {
        audioEl.pause();
      }, 5500);
    }
  }, []);

  return (
    <>
      <Link
        to="#notifications"
        className="dropdown-toggle nk-quick-nav-icon"
        data-toggle="dropdown"
      >
        <div
          className={hasNewNotification ? 'icon-status icon-status-info' : ''}
        >
          <em className="icon ni ni-bell" />
        </div>
        <button onClick={onPlay} id="audioButton" style={{ display: 'none' }} />
        <audio className="audio-element" style={{ display: 'none' }}>
          <source src="./assets/sino.mp3" />
        </audio>
      </Link>
      <div className="dropdown-menu dropdown-menu-xl dropdown-menu-right">
        <div className="dropdown-head">
          <span className="sub-title nk-dropdown-title">Notificações</span>
          {/* <Link to="#all">Mark All as Read</Link> */}
        </div>
        <div className="dropdown-body">
          <div className="nk-notification">
            {notifications.map(notification => (
              <Link
                to={notification.link}
                className="nk-notification-item dropdown-inner"
                key={notification.uid}
              >
                <div className="nk-notification-icon">
                  <em className="icon icon-circle bg-primary-dim ni ni-invest" />
                </div>
                <div className="nk-notification-content">
                  <div className="nk-notification-text">
                    {notification.description}
                  </div>
                  <div className="nk-notification-time">
                    {notification.created_at_formatted}
                  </div>
                </div>
              </Link>
            ))}
            {/* <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-info-dim ni ni-edit" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                Iliash <span>invited</span> you to edit <span>DashLite</span>{' '}
                folder
              </div>
              <div className="nk-notification-time">2 hrs ago</div>
            </div>
          </div>
          <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-primary-dim ni ni-share" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                You have shared <span>project v2</span> with Parvez.
              </div>
              <div className="nk-notification-time">7 days ago</div>
            </div>
          </div>
          <div className="nk-notification-item dropdown-inner">
            <div className="nk-notification-icon">
              <em className="icon icon-circle bg-success-dim ni ni-spark" />
            </div>
            <div className="nk-notification-content">
              <div className="nk-notification-text">
                Your <span>Subscription</span> renew successfully.
              </div>
              <div className="nk-notification-time">2 month ago</div>
            </div>
          </div> */}
          </div>
        </div>
        {notifications.length === 0 && (
          <div className="dropdown-foot center">
            Você não possui notificações.
          </div>
        )}
      </div>
    </>
  );
};

export default Notifications;
